import script from "./ChatResourceView.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatResourceView.vue?vue&type=script&setup=true&lang=js"

import "./ChatResourceView.vue?vue&type=style&index=0&id=a5a0d5fc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a5a0d5fc"]])

export default __exports__